import { ApiError } from 'src/api/generated';

/**
 * Identifies the retryable conversation conflict already explained by the mutation hook.
 * @param error - Rejected mutation error.
 * @returns Whether callers should retain the conflict-specific retry warning.
 */
export const isConversationOperationConflict = (error: unknown): boolean => {
  const body: unknown = error instanceof ApiError ? error.body : undefined;
  return (
    error instanceof ApiError &&
    error.status === 409 &&
    body !== null &&
    typeof body === 'object' &&
    'details' in body &&
    body.details !== null &&
    typeof body.details === 'object' &&
    'code' in body.details &&
    body.details.code === 'CONVERSATION_OPERATION_CONFLICT'
  );
};

/**
 * Identifies the existing API validation error for a duplicate active contact/funnel.
 * @param error - Rejected restoration or status mutation.
 * @returns Whether the mutation hook explains that the move could not be committed.
 */
export const isConversationActiveDuplicate = (error: unknown): boolean => {
  const body: unknown = error instanceof ApiError ? error.body : undefined;
  return (
    error instanceof ApiError &&
    error.status === 400 &&
    body !== null &&
    typeof body === 'object' &&
    'error' in body &&
    body.error ===
      'Cannot unarchive conversation: an active conversation already exists for this contact and funnel'
  );
};
